import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Text } from '../../../ui/Typography/Typography'
import { ModalContentWrapper } from '../../../ui/v2/Modal/ModalContentWrapper'

interface DeleteGroupModalProps {
  onCancel: () => void
  onApply: () => Promise<void>
}

export const DeleteGroupModal: FC<DeleteGroupModalProps> = (props) => {
  const { onApply, onCancel } = props

  const { t } = useTranslation()

  return (
    <ModalContentWrapper
      title={t('Please, confirm your action')}
      applyLabel={t('Confirm')}
      onCancel={onCancel}
      onConfirm={onApply}
      isCancelShownOnDesktop
    >
      <Text>{t('IB.RebatesPage.GroupsPage.You are trying to delete the Group(s)')}</Text>
    </ModalContentWrapper>
  )
}
